var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0d100;}.b{fill:#141414;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,44V4H44V44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.16,33.93c.75,1.27,1.6,2.45,3.33,2.45s2.23-.74,2.23-1.75-.84-1.67-2.45-2.36l-.89-.4c-2.6-1.09-4.31-2.5-4.31-5.38a4.77,4.77,0,0,1,4.81-4.74,3.84,3.84,0,0,1,.48,0,5.34,5.34,0,0,1,5.11,2.87l-2.8,1.78a2.5,2.5,0,0,0-2.22-1.53,1.56,1.56,0,0,0-1.67,1.39v.14c0,1.07.67,1.51,2.23,2.22l.89.38c3.07,1.28,4.77,2.62,4.77,5.6S37,39.53,33.61,39.53a6.67,6.67,0,0,1-6.28-3.7ZM17.33,34A3,3,0,0,0,20,35.8c1.18,0,1.84-.47,1.84-2.22V21.78h3.67V34.11a4.9,4.9,0,0,1-4.27,5.44,5,5,0,0,1-1.09,0,6.51,6.51,0,0,1-5.75-3.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.9ad43faeef07df3fe906e22ca9a7fbac.svg";
export { ForwardRef as ReactComponent };